import { render, staticRenderFns } from "./standardblock.vue?vue&type=template&id=3fe8d8c7&"
import script from "./standardblock.vue?vue&type=script&lang=js&"
export * from "./standardblock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports